import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { RECOMMEND_GOODS_URL } from '../../utils/urls';
import instance from "../../services/services";
import useUserStore from "../../store/userStore";
import ProductSection from '../../components/Product/ProductSection';
import { useLanguage } from '../../hooks/useLanguage';

function CartConfirmPopup({ isPopup, setIsPopup, goods_seq, orderMethod }){

  const location = useLocation();
  const navigation = useNavigate();
  const { userInfo } = useUserStore();
  const [popupActive, setPopupActive] = useState(false);
  const [recommendGoods, setRecommendGoods] = useState([]);
  const { t } = useLanguage();

  useEffect(() => {
      const body = document.body;
      body.style.overflow = isPopup ? 'hidden' : 'auto';
      return () => {
          body.style.overflow = 'auto';
      };
  }, [isPopup]);

  useEffect(() => {
      let timeout;
      if (isPopup) {
          timeout = setTimeout(() => {
              setPopupActive(true);
          }, 100);
      } else {
          setPopupActive(false);
      }
      return () => clearTimeout(timeout);
  }, [isPopup]);

  useEffect(() => {
      document.body.style.overflow = 'auto';
  }, [location]);

  const handleClose = (e) => {
    e.preventDefault();
    setIsPopup(false);
  };
  // 딤 배경 클릭 핸들러 추가
  const handleBackgroundClick = (e) => {
    // popup-box-component 클래스를 가진 최상위 div를 클릭했을 때만 팝업 닫기
    if (e.target.className === 'popup-box-component') {
      setIsPopup(false);
    }
  };

  useEffect(() => {
    const fetchRecommendGoods = async () => {
      try {
        const response = await instance.post(RECOMMEND_GOODS_URL, {
          goods_seq: goods_seq,
          member_seq: userInfo.member_seq,
          limit: 10,
        });
        setRecommendGoods(response.data.data.data);
      } catch (error) {
        console.error('추천 상품 데이터 가져오기 실패:', error);
      }
    };
    
    fetchRecommendGoods();
  }, [goods_seq, userInfo.member_seq]);


  const sectionSwiperOptions = {
    slidesPerView: 2, // 기본값 (480px 미만)
    slidesPerGroup: 2, // 기본값 (480px 미만)
    spaceBetween: 8,
    autoHeight: false,
    pagination: { clickable: true },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      480: {
        slidesPerView: 2,
        spaceBetween: 8,
        slidesPerGroup: 2
      },
      768: { 
        slidesPerView: 2, 
        spaceBetween: 12,
        slidesPerGroup: 2
      },
      1280: { 
        slidesPerView: 5, 
        spaceBetween: 18,
        slidesPerGroup: 5
      }
    }
  };

  
  // 계속 쇼핑하기
  const handleContinueShopping = () => {
    setIsPopup(false);
  };

  // 장바구니 클릭
  const handleCartClick = () => {
    // 선택된 주문 방식에 따라 다른 탭으로 이동
    if (orderMethod === 'visit') {
      navigation('/order/visit');
    } else if (orderMethod === 'parcel') {
      navigation('/order/parcel');
    } else {
      navigation('/order/sale');
    }
  };

  // 팝업 내부의 상품 클릭 처리
  useEffect(() => {
      if (!isPopup) return;

      const handleProductClick = (e) => {
          // 상품 div 클릭 확인
          const productDiv = e.target.closest('.default_prod.prod_item');
          if (productDiv) {
              // 하트 버튼 클릭이 아닌 경우에만 처리
              if (!e.target.classList.contains('wish_btn') && !e.target.closest('.wish_box')) {
                  e.preventDefault();
                  e.stopPropagation();
                  
                  // swiper-slide를 기준으로 인덱스 찾기
                  const swiperSlide = productDiv.closest('.swiper-slide');
                  if (swiperSlide) {
                      const slideIndex = Array.from(swiperSlide.parentNode.children).indexOf(swiperSlide);
                      if (recommendGoods[slideIndex]) {
                          const goodsSeq = recommendGoods[slideIndex].goods_seq;
                          
                          // 팝업 닫기
                          setIsPopup(false);
                          
                          // 페이지 이동
                          setTimeout(() => {
                              window.location.href = `/product/detail/${goodsSeq}`;
                          }, 100);
                      }
                  }
              }
          }
      };

      // 이벤트 리스너 추가
      document.addEventListener('click', handleProductClick, true);

      return () => {
          document.removeEventListener('click', handleProductClick, true);
      };
  }, [isPopup, recommendGoods, setIsPopup]);

  
  if (isPopup)
    return (
        <div 
          className="popup-box-component"
          onClick={handleBackgroundClick}
        >
          <div className={`box content lg ${popupActive ? 'active' : ''}`}>
            <div className="popup_container">
              {/* <h4 className="pop_title">{t('shopping_cart_check')}</h4> */}
              <div className='close_btn_con'>
                <button 
                  type="button" 
                  className="close_btn"
                  onClick={handleClose}
                />
              </div>
              <div className='confirm_text'>
                <i className='check_btn'></i>
                <span className='yell_30'>{t('shopping_cart_added_txt')}</span>
              </div>

              <section className="detail_desc">
                <h3><span className="d_yellow_text">{t('recommended_product')}</span> {t('product_specifications_empty4')}</h3>
                <div className="p0">
                  {recommendGoods.length > 0 ? (
                    <ProductSection
                      products={recommendGoods}
                      swiperOptions={sectionSwiperOptions}
                      showTabs={false}
                      showMoreButton={false}
                    />
                  ) : (
                    <div className="no_result">
                      <p>{t('product_specifications_empty5')}</p>
                    </div>
                  )}
                </div>
              </section>

              <div className='pop_btn_wrap two_btn'>
                <button
                  type="button"
                  className="default_btn white"
                  onClick={handleContinueShopping}
                >
                  {t('continue_shopping')}
                </button>
                <button
                  type="button"
                  className="default_btn yellow"
                  onClick={handleCartClick}
                >
                  {t('shopping_cart_view')}
                </button>
              </div>

            </div>
          </div>
        </div>
    );
};

export default CartConfirmPopup;